import { signal } from "@preact/signals-react"

export const configTemplateListSignal = signal([])
export const configTemplateListErrorSignal = signal(null)
export const configTemplateListLoadedSignal = signal(false)

export const configTemplateSignal = signal(null)
export const configTemplateErrorSignal = signal(null)
export const configTemplateLoadedSignal = signal(false)